import React from 'react'

import TextButton from 'LuxKit/Button/TextButton'
import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'
import noop from 'lib/function/noop'
import SearchExperience from 'tripPlanner/components/TripModal/TripItems/Search/SearchExperience'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'

type Props = {
  tripId: string
  sectionId: string
  onClick?: () => void
}

function ExperienceSearchModalCTA({
  tripId,
  sectionId,
  onClick = noop,
}: Props) {
  const openModal = useOpenModal()

  return (
    <TextButton
      kind="primary"
      startIcon={<LineSearchIcon />}
      onClick={() => {
        onClick()
        openModal(SearchExperience, { tripId, sectionId })
      }}
    >
      Search experiences
    </TextButton>
  )
}

export default ExperienceSearchModalCTA
